export const search = () => (
  <path
    d="M21 21l-4.35-4.35M19 11a8 8 0 11-16 0 8 8 0 0116 0z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
